.comment-author{color:#a0a1a3;font-size:12px;margin-top:8px}
/*# sourceMappingURL=test-result-comment.component-DEOXXKGE.css.map */
